import React, { useEffect, useState } from "react";
import "./editcv.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import EditExperience from "./EditExperience";
import EditEtude from "./EditEtude";
import EditInfo from "./EditInfo";
import EditLangue from "./Editlangue";
import EditLoisir from "./EditLoisir";
import { NotificationManager } from "react-notifications";
import AddExperience from "./addContent/AddExperience";
import AddEtude from "./addContent/AddEtude";
import Avvvatars from "avvvatars-react";
import Swal from 'sweetalert2';
import { SaveAll, Trash2 } from "lucide-react";
import AddLangue from "./addContent/AddLangue";
import AddInfo from "./addContent/AddInfo";
import AddOtherSkills from "./addContent/AddOtherSkills";

export default function EditCV() {
  const { id } = useParams();
  const [cvall, setCvall] = useState("");
  const [experience, setExperience] = useState("");
  const [etude, setEtude] = useState("");
  const [info, setInfo] = useState("");
  const [langue, setLangue] = useState("");
  const [loisir, setLoisir] = useState("");
  const [categorie, setCategorie] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [telephone2, setTelephone2] = useState("");
  const [facebook, setFacebook] = useState("");
  const [linkedin, setlinkedin] = useState("");
  const [adresse, setAdresse] = useState("");
  const [nationalite, setNationalité] = useState("");
  const [national, setNational] = useState("");
  const [dispo, setDispo] = useState("");
  const [post, setPost] = useState("");
  const [age, setAge] = useState("");
  const [status, setStatus] = useState("");
  const [aExp, setAexp] = useState("");
  const [contrat, setContrat] = useState("");
  const [sousCat, setSousCat] = useState([]);
  const [image, setImage] = useState(null);
  const [prenom, setPrenom] = useState("");
  const [pretention, setPretention] = useState("");
  const [descriptionProfil, setDescriptionProfil] = useState("");
  const [resume, setResume] = useState("");
  
  useEffect(() => {
    getCVID();

    axios.get("categorie_cvs").then((resp) => {
      if (resp.status === 200) {
        setCategorie(resp.data);
      }
    });
    axios.get("sous_categories").then((resp) => {
      if (resp.status === 200) {
        setSousCat(resp.data);
      }
    });
  }, [id]);

  const getCVID = () => {
    axios
      .get(`cvs/${id}`)
      .then((resp) => {
        if (id) {
          setCvall(resp.data.cv);
          setExperience(resp.data.exp);
          setEtude(resp.data.diplo);
          setInfo(resp.data.info);
          setLangue(resp.data.langage);
          setLoisir(resp.data.loisir);
        }
      })
      .catch((error) => console.log(error));
  };

  const profile = cvall;
  const handleSubmit = () => {
    const formdata = new FormData();
    if (name) {
      formdata.append("nomPrenom", name);
    }
    if (email) {
      formdata.append("email", email);
    }
    if (telephone) {
      formdata.append("telephone", telephone);
    }
    if (telephone1) {
      formdata.append("telephone", telephone1);
    }
    if (telephone2) {
      formdata.append("telephone", telephone2);
    }
    if (facebook) {
      formdata.append("facebook", facebook);
    }
    if (linkedin) {
      formdata.append("linkedin", linkedin);
    }
    if (adresse) {
      formdata.append("adresse", adresse);
    }
    if (nationalite) {
      formdata.append("nationalite", nationalite);
    }
    if (nationalite) {
      formdata.append("national", national);
    }
    if (dispo) {
      formdata.append("disponibility", dispo);
    }
    if (post) {
      formdata.append("categorie_cv_id", post);
    }
    if (age) {
      formdata.append("age", age);
    }
    if (aExp) {
      formdata.append("aExperience", aExp);
    }
    if (status) {
      formdata.append("status", status);
    }
    if (contrat) {
      formdata.append("contrat", contrat);
    }
    if (image) {
      formdata.append("photo", image);
    }
    if (prenom) {
      formdata.append("prenom", prenom);
    }
    if (pretention) {
      formdata.append("pretention", pretention);
    }
    if (descriptionProfil) {
      formdata.append("descriptionProfile", descriptionProfil);
    }
    if (resume) {
      formdata.append("resume", resume);
    }
    axios
      .put(`cvs/${id}`, formdata)
      .then((resp) => {
        if (resp.status === 200) {
          NotificationManager.success(
            `CV de ${profile.nomPrenom} modifier`,
            `Modification valider`,
            4000
          );
          axios.get(`cvs/${id}`).then((resp) => {
            setCvall(resp.data.cv);
            setExperience(resp.data.exp);
            setEtude(resp.data.diplo);
            setInfo(resp.data.info);
            setLangue(resp.data.langage);
            setLoisir(resp.data.loisir);
          });
        }
      })
      .catch((error) => console.log(error));
  };

  const handleDeleteCv = () => {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: "Vous ne pourrez pas annuler cette action!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1184ff',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`cvs/${id}`).then((response) => {
          if (response.status === 204) {
            NotificationManager.success(
              "Le CV a été supprimé avec succès",
              "Supprimé !",
              4000
            );
            window.location.replace("/cvtheque/cv");
          }
          console.log(response);
        });
      }
    });
  };

  function handleClick() {
    // Ouvre un input image
    const input = document.createElement("input");
    input.type = "file";
    input.click();

    // Attend que l'utilisateur sélectionne une image
    input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      setImage(file);
    });
  }
  console.log(profile);
  return (
    <>
      <div className="adminx-content">
        <div className="adminx-main-content">
          <div className="main-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center text-center">
                      {profile.photo && profile.photo.url ? (
                        <>
                          <span
                            onClick={handleClick}
                            alt="Admin"
                            className="rounded-circle p-1 bg-primary"
                          >
                            <Avvvatars size={110} value={profile.nomPrenom} />
                          </span>
                        </>
                      ) : (
                        <>
                          <img
                            src="https://bootdey.com/img/Content/avatar/avatar6.png"
                            alt="Admin"
                            className="rounded-circle p-1 bg-primary"
                            width="110"
                            onClick={handleClick}
                          />
                        </>
                      )}
                      <i
                        className="bi bi-camera-fill"
                        style={{ fontSize: "30px", position: "relative" }}
                        onClick={handleClick}
                      ></i>
                      <div className="mt-3">
                        <h4>{profile.nomPrenom} </h4>
                        {profile.sous_category_id ? (
                          <>
                            <GetSousCategorie id={profile.sous_category_id} />
                          </>
                        ) : (
                          <>
                            <GetCategorie id={profile.categorie_cv_id} />
                          </>
                        )}
                        <p className="text-muted font-size-sm">
                          {profile.adresse}{" "}
                        </p>
                        <strong>ID : {profile.id}</strong>
                        <br />
                        {profile.status === true ? (
                          <span class="badge badge-success text-white">Publier</span>
                        ) : (
                          <span class="badge badge-warning">Broullion</span>
                        )}
                      </div>
                    </div>
                    <hr className="my-4" />
                    <ul className="list-group list-group-flush">
                      <h5 className="d-flex align-items-center mb-3">
                        A propos de {profile.nomPrenom}
                      </h5>
                      <from>
                        <div className="row mb-3">
                          <div className="col-sm-4">
                            <label for="Nom">Nom</label>
                            <input
                                defaultValue={profile.nomPrenom}
                                type="text"
                                className="form-control h38"
                                name="nomPrenom"
                                onChange={(e) => setName(e.target.value)}
                              />
                          </div>
                          <div className="col-sm-4">
                            <label for="prenom">Prénom</label>
                            <input
                              defaultValue={profile.prenom}
                              type="text"
                              className="form-control h38"
                              name="nomPrenom"
                              onChange={(e) => setPrenom(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-4">
                            <label for="Age">Age</label>
                            <input
                              type="text"
                              className="form-control h38"
                              defaultValue={profile.age}
                              onChange={(e) => setAge(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-6">
                            <label for="email">Adresse mail</label>
                            <input
                              type="text"
                              defaultValue={profile.email}
                              className="form-control h38"
                              name="email"
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <label for="experience">Année d'experience(s)</label>
                            <select
                              type="text"
                              className="form-control"
                              onChange={(e) => setAexp(e.target.value)}
                            >
                              <option
                                defaultValue={profile.aExperience}
                                selected
                              >
                                {profile.aExperience}{" "}
                              </option>
                              <option value="1 an">1 an</option>
                              <option value="2 ans">2 ans</option>
                              <option value="3 ans">3 ans</option>
                              <option value="4 ans">4 ans</option>
                              <option value="4 ans">5 ans</option>
                              <option value="+ de 5 ans">+ de 5 ans</option>
                              <option value="+ de 10 ans">+ de 10 ans</option>
                            </select>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-4">
                            <label for="tel">Téléphone</label>
                            <input
                              type="text"
                              defaultValue={profile.telephone}
                              className="form-control h38"
                              onChange={(e) => setTelephone(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-4">
                            <label for="tel2">Autres téléphone</label>
                            <input
                              type="text"
                              defaultValue={profile.telephone1}
                              className="form-control h38"
                              onChange={(e) => setTelephone1(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-4">
                            <label for="tel3">Autre téléphone</label>
                            <input
                              type="text"
                              defaultValue={profile.telephone2}
                              className="form-control h38"
                              onChange={(e) => setTelephone2(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-6">
                            <label for="Facebook">Facebook</label>
                            <input
                              type="text"
                              className="form-control h38"
                              defaultValue={profile.facebook}
                              onChange={(e) => setFacebook(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <label for="Linkedin">Linkedin</label>
                            <input
                              type="text"
                              className="form-control h38"
                              defaultValue={profile.linkedin}
                              onChange={(e) => setlinkedin(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-4">
                            <label for="Adresse">Adresse exact</label>
                            <input
                              type="text"
                              className="form-control h38"
                              defaultValue={profile.adresse}
                              onChange={(e) => setAdresse(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-4">
                            <label for="Localisation">Localisation</label>
                            <select
                              type="text"
                              className="form-control"
                              onChange={(e) => setNationalité(e.target.value)}
                            >
                              <option
                                defaultValue={profile.nationalite}
                                selected
                              >
                                {profile.nationalite}{" "}
                              </option>
                              <option value="Madagascar">Madagascar</option>
                              <option value="Maurice">Maurice</option>
                              <option value="Autre resident">
                                Autre resident
                              </option>
                            </select>
                          </div>
                          <div className="col-sm-4">
                            <label for="national">Nationalité</label>
                            <select
                              type="text"
                              className="form-control"
                              onChange={(e) => setNational(e.target.value)}
                            >
                              <option
                                defaultValue={profile.nationalite}
                                selected
                              >
                                {profile.national}{" "}
                              </option>
                              <option value="Malgache">Malgache</option>
                              <option value="Mauricien">Mauricien</option>
                              <option value="Autre resident">
                                Autre nationalité
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-4">
                            <label for="Prétention">Prétention</label>
                            <input
                              type="text"
                              className="form-control h38"
                              defaultValue={profile.pretention}
                              onChange={(e) => setPretention(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-4">
                            <label for="Disponibilité">Disponibilité</label>
                            <select
                              type="text"
                              className="form-control"
                              onChange={(e) => setDispo(e.target.value)}
                            >
                              <option defaultValue={profile.disponibility}>
                                {profile.disponibility}{" "}
                              </option>
                              <option value="Disponible immediat">
                                Disponible immediat{" "}
                              </option>
                              <option value="preavis">
                                Disponible avec préavis{" "}
                              </option>
                              <option value="enposte">En poste</option>
                            </select>
                          </div>
                          <div className="col-sm-4">
                            <label for="Contrat">Contrat</label>
                            <select
                              type="text"
                              className="form-control"
                              onChange={(e) => setContrat(e.target.value)}
                            >
                              <option defaultValue={profile.contrat}>
                                {profile.contrat}{" "}
                              </option>
                              <option value="CDI">CDI </option>
                              <option value="CDD"> CDD </option>
                            </select>
                          </div>
                        </div>
                        {profile.sous_category_id ? (
                          <>
                            <div className="row mb-3">
                              <div className="col">
                                <label for="Post">Post</label>
                                <select
                                  type="text"
                                  className="form-control"
                                  onChange={(e) => setPost(e.target.value)}
                                >
                                  <option selected>
                                    <GetSousCategorie
                                      id={profile.sous_category_id}
                                    />
                                  </option>
                                  {sousCat &&
                                    sousCat.map((cat) => {
                                      return (
                                        <>
                                          <option value={cat.id}>
                                            {cat.categorie}{" "}
                                          </option>
                                        </>
                                      );
                                    })}
                                </select>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="row mb-3">
                              <div className="col">
                                <label for="Post">Post</label>
                                <select
                                  type="text"
                                  className="form-control"
                                  onChange={(e) => setPost(e.target.value)}
                                >
                                  <option selected>
                                    <GetCategorie
                                      id={profile.categorie_cv_id}
                                    />
                                  </option>
                                  {categorie &&
                                    categorie.map((cat) => {
                                      return (
                                        <>
                                          <option value={cat.id}>
                                            {cat.categorie}{" "}
                                          </option>
                                        </>
                                      );
                                    })}
                                </select>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="row mb-3">
                          <div className="col">
                            <label for="Description">Description</label>
                            <textarea
                              type="text"
                              className="form-control"
                              defaultValue={profile.descriptionProfile}
                              onChange={(e) =>
                                setDescriptionProfil(e.target.value)
                              }
                            ></textarea>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-6">
                            <label for="Changer">Changer le CV</label>
                            <input
                              type="file"
                              className="form-control"
                              onChange={(e) => setResume(e.target.files[0])}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-sm-3">
                            <label for="Status">Status</label>
                            <select
                              type="text"
                              className="form-control"
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              {profile.status === true ? (
                                <>
                                  <option value="true" selected>
                                    Publier
                                  </option>
                                  <option value="false">Brouillon</option>
                                </>
                              ) : (
                                <>
                                  <option value="false" selected>
                                    Brouillon
                                  </option>
                                  <option value="true">Publier</option>
                                </>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3"></div>
                          <div className="col-sm-9 text-secondary">
                            <button
                              onClick={handleSubmit}
                              type="submit"
                              className="btn btn-primary btn-sm"
                              title="Enregistrer les modifications"
                            >
                              <SaveAll size={20} strokeWidth={1.5} />&nbsp;
                              Enregistrer
                            </button>
                            &nbsp;
                            <button
                              onClick={handleDeleteCv}
                              type="button"
                              className="btn btn-danger btn-sm"
                              title="Enregistrer les modifications"
                            >
                              <Trash2 size={20} strokeWidth={1.5} />&nbsp; Supprimer
                              le CV
                            </button>
                          </div>
                        </div>
                      </from>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <h5 className="d-flex align-items-center mb-3">
                        Experience ({experience.length}){" "}
                    </h5>
                    {experience &&
                      experience.map((exp) => {
                        return (
                          <>
                            <EditExperience data={exp} idCv={profile.id} />
                            <hr className="my-4" />
                          </>
                        );
                      })}
                    <AddExperience idCv={profile.id} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="d-flex align-items-center mb-3">
                            Etudes et formations ({etude.length}){" "}
                        </h5>
                        {etude &&
                          etude.map((diplo) => {
                            return (
                              <>
                                <EditEtude id={diplo} idCv={profile.id} />
                                <hr className="my-4" />
                              </>
                            );
                          })}
                        <AddEtude idCv={profile.id} />
                      </div>
                    </div>
                  </div>
                </div>               
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                      <h5 className="d-flex align-items-center mb-3">Connaissance en informatique ({info.length})</h5>
                      {info && info.length > 0 && (
                        <>
                        {info.map((infor) => (
                          <React.Fragment key={infor}>
                            <EditInfo id={infor} />
                            <hr className="my-4" />
                          </React.Fragment>
                        ))}
                        </>
                      )}
                        <AddInfo idCv={profile.id} />
                      </div>
                    </div>
                  </div>
                </div>                                
                <div className="card">
                  <div className="card-body">
                  <h5 className="d-flex align-items-center mb-3">Langues ({langue.length}){" "}</h5>
                  {langue && langue.length > 0 && (
                    <ul className="list-group list-group-flush">
                      {langue &&
                        langue.map((lang) => {
                          return (
                            <>
                              <EditLangue id={lang} />
                              <hr className="my-4" />
                            </>
                          );
                        })}
                    </ul>
                    )}
                    <AddLangue idCv={profile.id} />
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                  <h5 className="d-flex align-items-center mb-3">Autre compétence ({loisir.length}){" "}</h5>
                    {loisir && loisir.length > 0 && (
                    <ul className="list-group list-group-flush">
                      {loisir &&
                        loisir.map((loi) => {
                          return (
                            <>
                              <EditLoisir id={loi} />
                              <hr />
                            </>
                          );
                        })}
                    </ul>
                    )}
                    <AddOtherSkills idCv={profile.id} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function GetCategorie({ id }) {
  const [cat, setCat] = useState("");
  useEffect(() => {
    if (id) {
      axios
        .get(`categorie_cvs/${id}`)
        .then((resp) => {
          if (resp.status === 200) {
            setCat(resp.data.cat);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [id]);
  return (
    <>
      <strong className="text-secondary mb-1">{cat.categorie} </strong>
    </>
  );
}

function GetSousCategorie({ id }) {
  const [sousCat, setSousCat] = useState("");
  useEffect(() => {
    if (id) {
      axios
        .get(`sous_categories/${id}`)
        .then((resp) => {
          if (resp.status === 200) {
            setSousCat(resp.data);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [id]);
  return (
    <>
      <strong className="text-secondary mb-1">{sousCat.categorie} </strong>
    </>
  );
}
